// Single transaction row — displays account name(s) and description.
import { Trash2, Pencil } from "lucide-react";
import { CategoryIcon } from "@/components/CategoryIcon";
import { styleFor } from "@/lib/txTypes";

export function TxRow({ tx, cat, lang, acctMap, onDelete, onEdit }) {
  const st = styleFor(tx.type);
  const src = acctMap[tx.account_id]?.name;
  const dst = acctMap[tx.to_account_id]?.name;
  const acctLabel = tx.type === "transfer" && dst ? `${src || "?"} → ${dst}` : (src || dst || "");
  return (
    <div className="p-4 rounded-2xl bg-card border border-border flex items-center gap-3 hover:border-primary/40 transition-colors overflow-hidden w-full" style={{ borderInlineStartWidth: 4, borderInlineStartColor: st.color }}>
      <div className="w-11 h-11 rounded-2xl grid place-items-center shrink-0" style={{ background: `${st.color}1a`, color: st.color }}>
        <CategoryIcon name={cat?.icon || "Tag"} />
      </div>
      <div className="min-w-0 flex-1 overflow-hidden">
        <p className="font-medium truncate">{tx.description || tx.product_name || (cat && (cat[lang] || cat.en))}</p>
        <p className="text-xs text-muted-foreground truncate">{(cat && (cat[lang] || cat.en)) || tx.category} · {tx.date}</p>
        {acctLabel && (
          <p className="text-[11px] font-semibold text-primary/80 truncate mt-0.5" data-testid={`tx-${tx.id}-account`}>
            <span className="opacity-70">{lang === "ar" ? "الحساب: " : "Account: "}</span>{acctLabel}
          </p>
        )}
      </div>
      <div className="font-display font-bold tabular-nums text-sm sm:text-base shrink-0 whitespace-nowrap" style={{ color: st.color }}>{st.sign}{tx.final_currency} {Number(tx.final_amount).toLocaleString()}</div>
      <button data-testid={`tx-edit-${tx.id}`} onClick={onEdit} className="p-2 rounded-xl hover:bg-primary/10 hover:text-primary transition-colors shrink-0" aria-label="Edit">
        <Pencil className="w-4 h-4" />
      </button>
      <button data-testid={`tx-del-${tx.id}`} onClick={onDelete} className="p-2 rounded-xl hover:bg-warn/10 hover:text-warn transition-colors shrink-0" aria-label="Delete">
        <Trash2 className="w-4 h-4" />
      </button>
    </div>
  );
}
